import styles from './style.module.scss';
import { Col, Divider, Row, Spin, Table, Typography } from 'antd';
import useInvoicesCategoryTickets from '../useInvoicesCategoryTickets';
import UIHelper from '../../../../../helpers/UIHelper';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    columns2,
    format,
    title,
    loading,
    summary,
    summary2,
    searchParams,
    filters,
  } = useInvoicesCategoryTickets(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>
                  Sales by Category / Tickets
                </Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns)}
                    dataSource={data.table1}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary}
                    scroll={{}}
                  />
                </Col>
                <Divider />
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns2)}
                    dataSource={data.table2}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary2}
                    scroll={{}}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12} className={'chartColl'}>
              <BarChangeChart
                keys={['Inc. % Tickets YTD', 'Inc. % Tickets LY']}
                data={data}
                format={format}
                itemWidth={130}
                translateXBar={-20}
              />
              <br />
              <BarChangeChart
                keys={['Inc. % Tickets YTD', 'Inc. % Tickets LY']}
                data={data.bar2}
                format={format}
                itemWidth={130}
                translateXBar={-20}
                lineMargins={{ top: 50, right: 150, bottom: 100, left: 115 }}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
